module.exports = __webpack_public_path__ + "img/menu-relatorios.2aa818bd.png";